import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, AlertTriangle, RefreshCw, Infinity as InfinityIcon } from 'lucide-react';
const results = ['Más claridad clínica', 'Más seguridad profesional', 'Más estructura', 'Menos improvisación', 'Más herramientas reales', 'Más tranquilidad al trabajar'];
export function ReassuranceSection() {
  return <section className="py-16 bg-white" data-id="element-190">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-191">
        {/* Result */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-slate-50 rounded-3xl p-8 md:p-12 border border-slate-100 mb-12" data-id="element-192">
          <h2 className="font-serif text-2xl md:text-3xl font-bold text-navy-900 uppercase tracking-tight mb-8 text-center" data-id="element-193">
            El resultado para vos como psicopedagoga
          </h2>
          <div className="grid sm:grid-cols-2 gap-x-8 gap-y-4 max-w-2xl mx-auto mb-6" data-id="element-194">
            {results.map((r, i) => <div key={i} className="flex items-center gap-3" data-id="element-195">
                <CheckCircle2 className="w-5 h-5 text-green-500 shrink-0" data-id="element-196" />
                <span className="text-slate-700 font-medium" data-id="element-197">{r}</span>
              </div>)}
          </div>
          <p className="text-center font-serif italic text-lg text-pink-600" data-id="element-198">
            Todo sin sentirte sola frente a la clínica real.
          </p>
        </motion.div>

        {/* Important note */}
        <div className="bg-amber-50 border border-amber-200 rounded-3xl p-8 mb-10" data-id="element-199">
          <div className="flex items-start gap-4 mb-4" data-id="element-200">
            <AlertTriangle className="w-6 h-6 text-amber-600 shrink-0 mt-0.5" data-id="element-201" />
            <div data-id="element-202">
              <h3 className="font-bold text-amber-900 uppercase tracking-tight text-lg mb-2" data-id="element-203">
                Primera aclaración (muy importante)
              </h3>
              <p className="text-slate-700 mb-3" data-id="element-204">
                Esto <span className="font-bold" data-id="element-205">NO</span> es un ebook teórico
                para leer y dejar guardado.
              </p>
              <p className="text-slate-700 font-semibold mb-4" data-id="element-206">
                👉 Venís a resolver situaciones reales de clínica.
              </p>
              <div className="grid sm:grid-cols-2 gap-2" data-id="element-207">
                {['Herramientas concretas', 'Recursos aplicables', 'Material organizado', 'Guías claras', 'Estructuras listas para usar'].map((t, i) => <span key={i} className="text-sm text-slate-700 flex items-center gap-2" data-id="element-208">
                    <CheckCircle2 className="w-4 h-4 text-amber-600" data-id="element-209" /> {t}
                  </span>)}
              </div>
            </div>
          </div>
        </div>

        {/* Flexibility + Lifetime access */}
        <div className="grid md:grid-cols-2 gap-6" data-id="element-210">
          <div className="bg-pink-50/50 rounded-3xl p-8 border border-pink-100" data-id="element-211">
            <div className="w-12 h-12 rounded-2xl bg-pink-200 text-pink-700 flex items-center justify-center mb-4" data-id="element-212">
              <RefreshCw className="w-6 h-6" data-id="element-213" />
            </div>
            <h3 className="font-bold text-navy-900 text-lg uppercase tracking-tight mb-2" data-id="element-214">
              Flexibilidad total
            </h3>
            <p className="text-slate-600 mb-4 text-sm" data-id="element-215">
              Podés usar el contenido como quieras:
            </p>
            <ul className="space-y-2 mb-4" data-id="element-216">
              {['Descargarlo', 'Imprimirlo', 'Editarlo', 'Adaptarlo a tus pacientes', 'Usarlo las veces que quieras'].map((t, i) => <li key={i} className="flex items-center gap-2 text-sm text-slate-700" data-id="element-217">
                  <CheckCircle2 className="w-4 h-4 text-pink-600" data-id="element-218" /> {t}
                </li>)}
            </ul>
            <p className="font-bold text-pink-700" data-id="element-219">👉 El material es tuyo.</p>
          </div>

          <div className="bg-rose-50/50 rounded-3xl p-8 border border-rose-100" data-id="element-220">
            <div className="w-12 h-12 rounded-2xl bg-rose-200 text-rose-700 flex items-center justify-center mb-4" data-id="element-221">
              <InfinityIcon className="w-6 h-6" data-id="element-222" />
            </div>
            <h3 className="font-bold text-navy-900 text-lg uppercase tracking-tight mb-2" data-id="element-223">
              Acceso de por vida
            </h3>
            <p className="text-slate-600 mb-4 text-sm" data-id="element-224">
              💡 Tu acceso es permanente. Y además:
            </p>
            <ul className="space-y-2 mb-4" data-id="element-225">
              {['🔄 El contenido puede seguir ampliándose', '➕ Se agregan nuevos recursos', '🧠 Mejoras constantes'].map((t, i) => <li key={i} className="flex items-center gap-2 text-sm text-slate-700" data-id="element-226">
                  <span className="font-medium" data-id="element-227">{t}</span>
                </li>)}
            </ul>
            <p className="font-bold text-rose-700" data-id="element-228">👉 Sin volver a pagar.</p>
          </div>
        </div>
      </div>
    </section>;
}